// extracted by mini-css-extract-plugin
module.exports = {"button__bar":"slick_button__bar__1Ia-A","slick-active":"slick_slick-active__1vQSo","slick-slide":"slick_slick-slide__2q-Ai"};